import React, { ReactNode } from 'react';

import { InteractionProvider as BaseInteractionProvider } from './interaction-context';
import { interactionService } from './interaction-service';

interface DefaultInteractionProviderProps {
	children: ReactNode;
}

/**
 * Default InteractionProvider that automatically uses the singleton interaction service
 * This makes it easy to wrap the app without needing to manually create the service
 */
export const DefaultInteractionProvider: React.FC<DefaultInteractionProviderProps> = ({ children }) => {
	return (
		<BaseInteractionProvider interactionService={interactionService}>
			{children}
		</BaseInteractionProvider>
	);
};

export default DefaultInteractionProvider;
